import clx from 'classnames';
import styles from './HomeInfoCards.module.scss';

const DeltaBadge = ({ value, isPercent, positive, hint, stopBubbleProps }) => {
  if (!isPercent || !value) return null;

  const numeric = parseFloat(String(value).replace('%', '').replace(/[−-]/g, ''));
  if (Number.isNaN(numeric) || numeric === 0) return null;

  const label = `${positive ? '+' : '−'}${String(value).replace('-', '')}`;

  return (
    <span
      className={clx(styles.performance_delta, {
        [styles.performance_delta_positive]: positive,
        [styles.performance_delta_negative]: !positive,
        [styles.performance_delta_hint]: !!hint,
      })}
      tabIndex={hint ? 0 : undefined}
      aria-label={hint ? `${label}. ${hint}` : label}
      {...(stopBubbleProps || {})}
    >
      {label}
      {hint ? (
        <span className={styles.performance_delta_tooltip} role="tooltip">
          {hint}
        </span>
      ) : null}
    </span>
  );
};

export default DeltaBadge;
